import { useEffect } from "react";
import I18n from "i18n-js";
import { getAuth, Unsubscribe } from "firebase/auth";
import { useDialog } from "app/hook";
import { DialogType } from "app/types";
import { getEnv } from "app/configSlice";
import { parentsFirebase } from "app/Auth";
import { createParentAccount } from "features/user/api";

export const useSignUp = () => {
  const handleDialog = useDialog();

  useEffect(() => {
    let unsubscribe: Unsubscribe;

    try {
      const childrenAuth = getAuth();
      const auth = getAuth(parentsFirebase);
      unsubscribe = auth.beforeAuthStateChanged(async (user) => {
        try {
          if (user) {
            if (!user.isAnonymous) {
              const locale = I18n.locale.split("_");
              let email: string;
              if (
                user.providerData[0].providerId === "google.com" ||
                user.providerData[0].providerId === "apple.com"
              ) {
                email = user.providerData[0].email;
              } else {
                email = user.email;
              }
              await createParentAccount({
                user: {
                  uid: user.uid,
                  child_uid: childrenAuth.currentUser?.uid,
                  email: email,
                  provider: user.providerData[0].providerId,
                  display_name: I18n.t("MSG_PARENTS_PROFILE_DEFAULT_NAME"),
                  language: {
                    locale:
                      locale.slice(0, locale.length - 1).join("_") || "ja",
                    format: locale[locale.length - 1] || "katakana",
                  },
                  env: getEnv(),
                  timezone: "Asia/Tokyo",
                  country: "ja",
                },
              });
              if (childrenAuth.currentUser?.uid) {
                await childrenAuth.signOut();
              }
            }
          }

          unsubscribe();
        } catch (error) {
          console.log(error);
          unsubscribe();
          handleDialog({ type: DialogType.ERROR_NETWORK, value: true });
        }
      });
    } catch (error) {
      handleDialog({ type: DialogType.ERROR_NETWORK, value: true });
    }
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);
};
